import { Api } from "@penn/web-common";
import { unwrap } from "@penn/web-common";

export interface LandingParagraph {
  categoryKey: string;
  sortOrder: number;
  paragraphText: string;
}

export interface LandingBullet {
  categoryKey: string;
  sortOrder: number;
  bulletText: string;
}

export interface LandingImage {
  categoryKey: string;
  sortOrder: number;
  productId: string | null;
  imageUrl: string;
  caption: string;
}

export interface LandingCategory {
  categoryKey: string;
  title: string;
  subtitle: string;
  tip: string;
  /** Relative S3 key (e.g. "media/Handtools.mp4") or absolute URL. Base URL
   * lives in VITE_MEDIA_BASE_URL — never hardcode the bucket/CDN host. */
  videoUrl: string | null;
  sortOrder: number;
  paragraphs: LandingParagraph[];
  bullets: LandingBullet[];
  images: LandingImage[];
}

export interface LandingContentData {
  meta: {
    version: string;
    generatedFrom: string;
    generatedAt: string;
  };
  categories: LandingCategory[];
}

export async function getLandingContent(): Promise<LandingContentData> {
  const res = await Api.get("/v1/landing-content");
  return unwrap<LandingContentData>(res.data);
}
